import React from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';

import Media from 'css/Media';

const Chamburger = props => {
    return (
        <Wrapper 
            open={props.open}
            isDark={props.isDark}
            cartFilled={props.booking.reservations.length ? 1 : 0}
        >
            { !!props.booking.reservations.length &&
                <svg>
                    <circle />
                </svg>
            }
            <span />
        </Wrapper>
    )
}

const mapStateToProps = state => ({
    booking: state.booking
})

export default connect(mapStateToProps, null)(Chamburger);

const Wrapper = styled.button`
    margin-top: -3px;
    display: block;
    position: relative;
    cursor: pointer;
    width: 22px;
    height: 16px;

    span, &:before, &:after {
        content: '';
        width: 22px;
        height: 1px;
        background: ${props => props.open || props.isDark ? props.theme.colors.negative : props.theme.colors.text};
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateY(3px) translateX(-50%);
        display: block;
        transition: all .3s ease-in-out;
        transform-origin: 50% 50%;
    }

    svg {
        position: absolute;
        left: -8px;
        top: -8px;
        height: 16px;
        width: 16px;
        transition: all .3s ease-in-out;

        circle {
            cx: 8;
            cy: 8;
            r: 8;
            fill: ${props => props.theme.colors.button};
            transition: all .3s ease-in-out;
        }
    }

    &:before { 
        transform: translateY(-4px) translateX(-50%); 
    }

    &:after { 
        transform: translateY(10px) translateX(-50%);
    }

    ${props => props.cartFilled === 1 && css`
        &:before {
            width: 12px;
            transform: translateY(-4px) translateX(-7%);
        }
    `}
    
    ${props => props.open && css`
        margin-left: 0;
        
        &:before {
            transform: translateY(100%) translateX(-50%); 
        }

        &:after {
            transform: translateY(100%) translateX(-50%); 
        }

        span {
            transform: translateY(100%) translateX(-50%);
        }

        svg {
            width: 0;
            height: 0;

            circle {
                cx: 0;
                cy: 0;
                r: 0;
            }
        }
    `}

    ${Media.greaterThan('l')`
        margin-top: 0;
    `}
`